import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  ProgressBarWrapper,
  Thumb,
  TrackMini,
} from './styles';

import Fill from './Fill';
import Slider from './Slider';
import AdPoints from './AdPoints';
import { usePlayer } from '../../../PlayerContext';

const THUMB_SIZE = 12;

function ProgressBarMini(props) {
  const _thumb = useRef();
  const _track = useRef();
  const [trackWidth, setTrackWidth] = useState(0);
  const player = usePlayer();

  const {
    isPlayingAds,
    isAirPlaying,
    progress,
    seekEnabled,
  } = props;

  useEffect(() => {
    setTrackWidth(_track.current?.offsetWidth);
  }, [_track]);

  const thumbOffsetPx = trackWidth * progress;

  const adsPointsOffset = player.adsPlayer?._adsPointsOffset || [];

  return (
    <ProgressBarWrapper>
      <TrackMini ref={_track}>
        <Fill
          color={isPlayingAds ? 'ads' : 'progressBarFillColor'}
          left="0"
          width={`${progress * 100}%`}
        />
        <AdPoints
          disabled={isPlayingAds || isAirPlaying}
          adsPointsOffset={adsPointsOffset}
          width={6}
        />
        {seekEnabled && (
          <Thumb
            ref={_thumb}
            style={{ left: `${thumbOffsetPx}px` }}
            className="miniThumb"
            height={THUMB_SIZE}
            width={THUMB_SIZE}
          />
        )}
        <Slider thumbHeight={THUMB_SIZE} thumbWidth={THUMB_SIZE} />
      </TrackMini>
    </ProgressBarWrapper>
  );
}

ProgressBarMini.propTypes = {
  isPlayingAds: PropTypes.bool.isRequired,
  isAirPlaying: PropTypes.bool.isRequired,
  progress: PropTypes.number.isRequired,
  seekEnabled: PropTypes.bool.isRequired,
};

export default React.memo(ProgressBarMini);
